import { useEffect, useState, useRef } from 'react';

// Define an interface for your data structure
interface HeaderData {
    title?: string;
    paragraph1?: string;
    paragraph2?: string;
    linkText?: string;
    linkUrl?: string;
    // Add other fields as needed
}
export function Instructions(props: any) {
    const [headerData, setHeaderData] = useState<Array<HeaderData>>([])
    useEffect(() => {
        getHeaderText()
    }, [])

    function getHeaderText() {

        var submitRequestUrl = process.env.REACT_APP_SERVER_URL_HEADER_TEXT ? process.env.REACT_APP_SERVER_URL_HEADER_TEXT.toString() : ""

        const getData = async () => {
            try {
                const response = await fetch(submitRequestUrl, {});

                // Check if response is OK
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                // Check if response has content
                const text = await response.text();
                if (!text) {
                    console.log("Empty response received");
                    return;
                }

                // Try to parse as JSON
                const result = JSON.parse(text);
                console.log("Header res: " + result);
                setHeaderData(result)
                
            } catch (error) {
                console.error("Error fetching header text:", error);
            }
        };
        getData();
    }

    useEffect(() => {
        console.log("Updated headerData:", headerData);
    }, [headerData]);

    return (
        <div className="row mt-3 pb-4 mb-4 mb">
            <div className="col-md-6">
                <h2>{headerData[0]?.title}</h2>
                <p>{headerData[0]?.paragraph1 || ""}</p>
                <p>{headerData[0]?.paragraph2 || ""}
                    {headerData[0]?.linkText && headerData[0]?.linkUrl && (
                        <>
                            {" "}
                            <a href={headerData[0]?.linkUrl} target="_blank" rel="noopener noreferrer">
                                {headerData[0]?.linkText}
                            </a>
                        </>
                    )}
                </p>
            </div>

            <div className="col-md-1 mb-4 mb mt-3">
            </div>

            <div className="col-md-5 mb-4 mb mt-3">
                <img alt="Constellation Power Delivery System Instructions" src="Assets/ConstellationInstructions.png" />
            </div>
        </div>
    );
}